"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4998],{

/***/ 4998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DateRangeForm; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(9198);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(1591);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js + 2 modules
var Tooltip = __webpack_require__(49161);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/FormControl.js
var FormControl = __webpack_require__(64436);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/DateRange.js
var DateRange = __webpack_require__(60625);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ArrowRight.js
var ArrowRight = __webpack_require__(52504);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Skeleton/Skeleton.js
var Skeleton = __webpack_require__(58365);
// EXTERNAL MODULE: ./node_modules/@datapunt/matomo-tracker-react/es/useMatomo.js + 1 modules
var useMatomo = __webpack_require__(86700);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
// EXTERNAL MODULE: ./components/ShippingInfos/ShippingInfos.tsx
var ShippingInfos = __webpack_require__(49172);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(75154);
;// CONCATENATED MODULE: ./components/DateRangeForm/DateRangeForm.style.tsx

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj, _obj1, _obj2, _obj3;
    return (0,createStyles/* default */.Z)({
        root: (_obj = {}, _defineProperty(_obj, theme.breakpoints.down('sm'), {
            '& .MuiButton-root': {
                display: 'block',
                margin: 'auto'
            }
        }), _defineProperty(_obj, theme.breakpoints.down('md'), {
            display: 'flex',
            flexDirection: 'column'
        }), _defineProperty(_obj, theme.breakpoints.up('md'), {
            display: 'inline-flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: theme.shape.borderRadius,
            gap: theme.spacing(1)
        }), _defineProperty(_obj, theme.breakpoints.up('xl'), {
            height: '100%',
            gap: theme.spacing(2)
        }), _obj),
        daterangeOneDay: _defineProperty({
            display: 'flex',
            background: theme.palette.common.white,
            boxShadow: theme.shadows[1],
            borderRadius: theme.shape.borderRadius
        }, theme.breakpoints.down('sm'), {
            display: 'block',
            margin: theme.spacing(0, 0, 1, 0)
        }),
        order1: _defineProperty({
            position: 'relative'
        }, theme.breakpoints.down('md'), {
            order: 1
        }),
        order2: _defineProperty({}, theme.breakpoints.down('md'), {
            order: 2
        }),
        shopLayout: _defineProperty({}, theme.breakpoints.up('md'), {
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center'
        }),
        shopLayoutLanding: _defineProperty({}, theme.breakpoints.up('md'), {
            justifyContent: 'flex-start'
        }),
        loaderOverlay: {
            position: 'absolute',
            zIndex: theme.zIndex.appBar,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'rgba(255,255,255, .5)',
            backdropFilter: 'blur(2px)'
        },
        loaderSizer: {
            height: '100%'
        },
        whenLoading: {
            overflow: 'hidden',
            '&:hover': {
                cursor: 'wait'
            }
        },
        when: (_obj1 = {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: theme.palette.primary.main,
            boxShadow: theme.shadows[1],
            borderRadius: theme.shape.borderRadius,
            background: theme.palette.common.white
        }, _defineProperty(_obj1, theme.breakpoints.down('xs'), {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
            flexWrap: 'wrap'
        }), _defineProperty(_obj1, theme.breakpoints.down('sm'), {
            marginBottom: theme.spacing(1)
        }), _defineProperty(_obj1, theme.breakpoints.up('lg'), {
            margin: theme.spacing(0, 1.5, 0, 0)
        }), _obj1),
        whenOneDay: _defineProperty({
            boxShadow: 'none'
        }, theme.breakpoints.up('lg'), {
            margin: 0
        }),
        when__icon: _defineProperty({
            marginLeft: theme.spacing(2)
        }, theme.breakpoints.down('xs'), {
            position: 'absolute',
            marginLeft: 0,
            left: theme.spacing(1)
        }),
        buttonHeight: _defineProperty({}, theme.breakpoints.down('md'), {
            width: '100%'
        }),
        iconArrow: {
            color: theme.palette.primary.main
        },
        datepicker: (_obj2 = {
            fontSize: 16,
            height: 48,
            borderRadius: theme.shape.borderRadius,
            color: theme.palette.primary.main,
            textAlign: 'center',
            border: 0,
            cursor: 'pointer',
            '&:focus': {
                outline: 'none'
            }
        }, _defineProperty(_obj2, theme.breakpoints.down('md'), {
            minWidth: 120,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            appearance: 'none',
            '& input': {
                color: theme.palette.primary.main,
                margin: 0,
                padding: theme.spacing(0.5, 0, 0, 1),
                '&:webkit-calendar-picker-indicator': {
                    display: 'none'
                }
            },
            '& .MuiInputBase-root:before, & .MuiInputBase-root:after': {
                display: 'none'
            }
        }), _defineProperty(_obj2, theme.breakpoints.up('md'), {
            fontSize: 14,
            fontFamily: theme.typography.fontFamily
        }), _obj2),
        datePickerText: {
            maxWidth: 300,
            margin: 'auto',
            color: theme.palette.secondary.main,
            textAlign: 'center',
            fontSize: '11px',
            padding: theme.spacing(0.5),
            borderBottomLeftRadius: theme.shape.borderRadius,
            borderBottomRightRadius: theme.shape.borderRadius,
            '&:empty': {
                display: 'none'
            }
        },
        datePickerWithText: {
            '& .react-datepicker': {
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0
            }
        },
        backgroundSolid: {
            backgroundColor: theme.extraColors.greyLight,
            borderBottomLeftRadius: theme.shape.borderRadius,
            borderBottomRightRadius: theme.shape.borderRadius
        },
        mobileInput: _defineProperty({
            fontFamily: 'inherit',
            borderRadius: 0,
            background: 'none',
            color: theme.palette.primary.main,
            width: '100%',
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            '&:hover,&:focus': {
                background: 'none'
            }
        }, theme.breakpoints.up('md'), {}),
        btnSubmit: {
            '&[disabled]': {
                cursor: 'wait',
                '&:hover,&:focus': {
                    cursor: 'wait'
                }
            }
        },
        show: {
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.shadows[1],
            animation: '$calendar-show .4s',
            willChange: 'transform, opacity'
        },
        hide: {
            animation: '$calendar-hide .2s',
            willChange: 'transform, opacity'
        },
        '@keyframes calendar-show': {
            '0%': {
                opacity: 0,
                transform: 'translate3d(0, -1px, 0)'
            },
            '100%': {
                opacity: 1,
                transform: 'translate3d(0, 0, 0)'
            }
        },
        '@keyframes calendar-hide': {
            '0%': {
                opacity: 1
            },
            '100%': {
                opacity: 0
            }
        },
        formControl: (_obj3 = {
            minWidth: 100
        }, _defineProperty(_obj3, theme.breakpoints.down('sm'), {
            marginBottom: theme.spacing(1),
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }), _defineProperty(_obj3, theme.breakpoints.up('lg'), {
            borderLeft: "1px solid ".concat(theme.extraColors.greyLight)
        }), _obj3),
        dayDurationSelctor: _defineProperty({
            fontSize: 14,
            color: theme.palette.primary.main,
            background: theme.palette.common.white,
            //appearance: 'none',
            textAlign: 'center',
            fontFamily: theme.typography.fontFamily,
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(1, 1),
            marginRight: theme.spacing(2),
            minWidth: 100,
            height: '100%',
            border: 'none'
        }, theme.breakpoints.down('md'), {
            minWidth: 50,
            margin: 0
        }),
        btnIcon: {
            display: 'block',
            maxWidth: '100%',
            height: 'auto'
        },
        btnIconSvg: {
            lineHeight: 1,
            '& .injected-svg': {
                display: 'inline-block',
                width: '1em',
                height: '1em',
                fontSize: '1.5rem',
                fill: 'currentColor',
                transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                flexShrink: 0,
                userSelect: 'none'
            }
        }
    });
});
/* harmony default export */ var DateRangeForm_style = (useStyles);

// EXTERNAL MODULE: ./components/Loader/Loader.tsx
var Loader = __webpack_require__(96149);
// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
// EXTERNAL MODULE: ./components/Global/CMSText.tsx
var CMSText = __webpack_require__(94455);
// EXTERNAL MODULE: ./redux/actions/promotions.ts + 1 modules
var promotions = __webpack_require__(18919);
// EXTERNAL MODULE: ./redux/helpers/requests.ts
var requests = __webpack_require__(20031);
// EXTERNAL MODULE: ./utils/businessDays.ts
var businessDays = __webpack_require__(67202);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/fr/index.js + 5 modules
var fr = __webpack_require__(75830);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/de/index.js + 5 modules
var de = __webpack_require__(70879);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/es/index.js + 5 modules
var locale_es = __webpack_require__(63345);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/nl/index.js + 5 modules
var nl = __webpack_require__(94638);
// EXTERNAL MODULE: ./hooks/useCart.ts
var useCart = __webpack_require__(19789);
// EXTERNAL MODULE: ./node_modules/react-svg/dist/react-svg.esm.js + 2 modules
var react_svg_esm = __webpack_require__(52933);
// EXTERNAL MODULE: ./utils/proxySvgUrl.ts
var proxySvgUrl = __webpack_require__(43359);
;// CONCATENATED MODULE: ./components/DateRangeForm/DateRangeForm.tsx
/* provided dependency */ var process = __webpack_require__(34155);

























//Add locale translations of date picker







function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function DateRangeForm_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            DateRangeForm_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
(0,react_datepicker_min.registerLocale)('fr', fr/* default */.Z);
(0,react_datepicker_min.registerLocale)('de', de/* default */.Z);
(0,react_datepicker_min.registerLocale)('es', locale_es/* default */.Z);
(0,react_datepicker_min.registerLocale)('nl', nl/* default */.Z);
function getMajeRentalLastDay() {
    return constants/* store */.h === 'maje' ? dayjs_min_default()('2026-06-30', 'YYYY-MM-DD') : null;
}
function getRentalEndMaxDate(startLeasingDate, maximumLeasingDays) {
    var fromParams = dayjs_min_default()(startLeasingDate, 'DD/MM/YYYY').add(maximumLeasingDays - 1, 'day');
    var majeLast = getMajeRentalLastDay();
    if (majeLast && fromParams.isAfter(majeLast)) {
        return majeLast.toDate();
    }
    return fromParams.toDate();
}
var MainTooltip = (0,withStyles/* default */.Z)(function(theme) {
    return {
        tooltip: {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.common.white,
            fontSize: 11,
            padding: theme.spacing(1)
        },
        arrow: {
            color: theme.palette.secondary.main
        }
    };
})(Tooltip/* default */.ZP);
var mapStateToProps = function(state) {
    return {
        cart: state.cart,
        promotions: state.promotions,
        parameters: state.parameters,
        stores: state.stores
    };
};
var mapDispatchToProps = {
    getPromotions: promotions/* getPromotions */.Fh,
    setCurrentPromotion: promotions/* setCurrentPromotion */.rs
};
var DateRangeForm_DateRange = function(param1) {
    var isLanding = param1.isLanding, cart = param1.cart, t = param1.t, parameters = param1.parameters, setCurrentPromotion1 = param1.setCurrentPromotion, getPromotions1 = param1.getPromotions, text = param1.text, textFunnel = param1.textFunnel, scrollTarget = param1.scrollTarget, stores = param1.stores, promotions = param1.promotions;
    var ref39, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24;
    var ref25 = (0,useCart/* useCart */.j)(), deleteCart = ref25.deleteCart, createCart = ref25.createCart, patchDatesCart = ref25.patchDatesCart;
    var classes = DateRangeForm_style();
    var theme = (0,useTheme/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var ref26 = (0,react.useState)(new Set()), publicHolidays = ref26[0], setPublicHolidays = ref26[1];
    var ref27 = (0,react.useState)(2), minDateRange = ref27[0], setMinDateRange = ref27[1];
    var ref28 = (0,react.useState)(dayjs_min_default()().add(7, 'day').toDate()), minStartDate = ref28[0], setMinStartDate = ref28[1];
    var ref29 = (0,react.useState)(dayjs_min_default()(minStartDate).add(1, 'day').toDate()), minEndDate = ref29[0], setMinEndDate = ref29[1];
    var ref30 = (0,react.useState)([]), excludedDatesStart = ref30[0], setExcludedDatesStart = ref30[1];
    var ref31 = (0,react.useState)([]), excludedDatesEnd = ref31[0], setExcludedDatesEnd = ref31[1];
    var ref32 = (0,react.useState)([]), daysOff = ref32[0], setDaysOff = ref32[1];
    var startRef = (0,react.useRef)();
    var endRef = (0,react.useRef)();
    var ref33 = (0,react.useState)(false), hasReduction = ref33[0], setHasReduction = ref33[1];
    var ref34 = (0,react.useState)(0), reduction = ref34[0], setReduction = ref34[1];
    var ref35 = (0,react.useState)(true), displayTooltip = ref35[0], setDisplayTooltip = ref35[1];
    var ref36 = (0,react.useState)(false), calendarFade = ref36[0], setCalendarFade = ref36[1];
    var ref37 = (0,react.useState)(false), dateLoading = ref37[0], setDateLoading = ref37[1];
    var ref38 = (0,react.useState)('day'), dayDuration = ref38[0], setDayDuration = ref38[1];
    var calendarIconPrismic = text === null || text === void 0 ? void 0 : text.datepickerbutton;
    var isCalendarIconDefined = (calendarIconPrismic === null || calendarIconPrismic === void 0 ? void 0 : calendarIconPrismic.url) && (calendarIconPrismic === null || calendarIconPrismic === void 0 ? void 0 : (ref39 = calendarIconPrismic.url) === null || ref39 === void 0 ? void 0 : ref39.length) > 0 && (calendarIconPrismic === null || calendarIconPrismic === void 0 ? void 0 : calendarIconPrismic.url.split('.').pop()) === 'svg';
    var trackEvent = (0,useMatomo/* default */.Z)().trackEvent;
    var dayDurationValues = [
        {
            value: 'day',
            text: text === null || text === void 0 ? void 0 : text.fullday,
            defaultText: t('texts:general:fullDay')
        },
        {
            value: 'morning',
            text: text === null || text === void 0 ? void 0 : text.morning,
            defaultText: t('texts:general:morning')
        },
        {
            value: 'afternoon',
            text: text === null || text === void 0 ? void 0 : text.afternoon,
            defaultText: t('texts:general:afternoon')
        },
        {
            value: 'evening',
            text: text === null || text === void 0 ? void 0 : text.evening,
            defaultText: t('texts:general:evening')
        }, 
    ];
    var CalendarIcon = isCalendarIconDefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
        src: (0,proxySvgUrl/* proxySvgUrl */.u)(calendarIconPrismic.url),
        className: (0,clsx_m/* default */.Z)('daterange__icon', 'daterange__icon--calendar', classes.btnIcon, classes.btnIconSvg),
        wrapper: "span"
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DateRange/* default */.Z, {
        className: (0,clsx_m/* default */.Z)('daterange__icon', 'daterange__icon--calendar', classes.when__icon)
    });
    var currentLocale = (0,react.useMemo)(function() {
        var lang = router.locale;
        if (router.locale === 'en') {
            var en_Region = process.env.NEXT_PUBLIC_EN_REGION;
            lang = "".concat(router.locale, "-").concat(en_Region && en_Region !== 'GB' ? en_Region : 'GB');
        }
        return lang !== null && lang !== void 0 ? lang : 'fr';
    }, [
        router.locale
    ]);
    var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('sm'));
    var isDesktop = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('md'));
    var isEnableChooseStartingDate = parameters === null || parameters === void 0 ? void 0 : (ref1 = parameters.items) === null || ref1 === void 0 ? void 0 : ref1.enableChooseStartingDate;
    var warehouseId = stores === null || stores === void 0 ? void 0 : (ref2 = stores.selectedStore) === null || ref2 === void 0 ? void 0 : ref2.warehouseId;
    if (!warehouseId && constants/* customWarehouse */.lL && !isNaN(+constants/* customWarehouse */.lL)) {
        warehouseId = +constants/* customWarehouse */.lL;
    }
    var minimumStartingDays = (stores === null || stores === void 0 ? void 0 : (ref3 = stores.selectedStore) === null || ref3 === void 0 ? void 0 : ref3.minimumStartingDays) ? stores.selectedStore.minimumStartingDays : parameters === null || parameters === void 0 ? void 0 : (ref4 = parameters.items) === null || ref4 === void 0 ? void 0 : ref4.minimumStartingDays;
    var minimumLeasingDays = (stores === null || stores === void 0 ? void 0 : (ref5 = stores.selectedStore) === null || ref5 === void 0 ? void 0 : ref5.minimumLeasingDays) ? (ref6 = stores.selectedStore) === null || ref6 === void 0 ? void 0 : ref6.minimumLeasingDays : parameters === null || parameters === void 0 ? void 0 : (ref7 = parameters.items) === null || ref7 === void 0 ? void 0 : ref7.minimumLeasingDays;
    var isSaturdayABusinessDay = parameters === null || parameters === void 0 ? void 0 : (ref8 = parameters.items) === null || ref8 === void 0 ? void 0 : ref8.isSaturdayABusinessDay;
    var disableSundayFromCms = !!(text === null || text === void 0 ? void 0 : text.disable_sunday_on_date_picker);
    var handleDateChangeRaw = function(event) {
        event.preventDefault();
    };
    (0,react.useEffect)(function() {
        var ref40;
        // find currently selected duration from cart
        if (cart === null || cart === void 0 ? void 0 : (ref40 = cart.item) === null || ref40 === void 0 ? void 0 : ref40.oneDayDuration) {
            setDayDuration(dayDurationValues.find(function(duration) {
                var ref;
                return duration.value === (cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.oneDayDuration);
            }).value);
        }
    }, []);
    (0,react.useEffect)(function() {
        if (!isNaN(minimumStartingDays)) {
            setMinStartDate((0,businessDays/* getMinimumStartDate */.uO)(minimumStartingDays, isSaturdayABusinessDay, publicHolidays, disableSundayFromCms).toDate());
        }
        if (!isNaN(minimumLeasingDays)) {
            setMinDateRange(minimumLeasingDays);
            setMinEndDate((0,businessDays/* getMinimumStartDate */.uO)(minimumStartingDays, isSaturdayABusinessDay, publicHolidays, disableSundayFromCms).add(minimumLeasingDays - 1, 'day').toDate());
        }
    }, [
        disableSundayFromCms,
        isSaturdayABusinessDay,
        minimumStartingDays,
        minimumLeasingDays,
        publicHolidays, 
    ]);
    (0,react.useEffect)(function() {
        calendarFade ? document === null || document === void 0 ? void 0 : document.body.classList.add('react-datepicker--open') : document === null || document === void 0 ? void 0 : document.body.classList.remove('react-datepicker--open');
    }, [
        calendarFade
    ]);
    (0,react.useEffect)(function() {
        var isMounted = true;
        var daysOffArr = _toConsumableArray(daysOff);
        var blockedStart = text === null || text === void 0 ? void 0 : text.blocked_dates_start;
        var blockedEnd = text === null || text === void 0 ? void 0 : text.blocked_dates_end;
        if (blockedStart !== null && typeof blockedStart !== 'undefined' && blockedEnd !== null && typeof blockedEnd !== 'undefined') {
            var excludedDates = [];
            blockedStart = new Date(blockedStart);
            blockedEnd = new Date(blockedEnd);
            while(blockedStart <= blockedEnd){
                excludedDates.push(new Date(blockedStart));
                blockedStart.setDate(blockedStart.getDate() + 1);
            }
            excludedDates.map(function(dates) {
                daysOffArr.push(dayjs_min_default()(dates).toDate());
            });
            if (isMounted) {
                setDaysOff(excludedDates);
                if (excludedDatesStart.length === 0) {
                    setExcludedDatesStart(excludedDates);
                }
                if (excludedDatesEnd.length === 0) {
                    setExcludedDatesEnd(excludedDates);
                }
            }
        }
        var fetchDaysOff = function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                var data, responseNow, responsePlusOne, dataNow, dataPlusOne, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, key;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            data = {};
                            _ctx.next = 4;
                            return fetch("".concat(requests/* ERequestUrl.apiGouvFr */.KU.apiGouvFr, "/").concat(dayjs_min_default()().year(), ".json"));
                        case 4:
                            responseNow = _ctx.sent;
                            _ctx.next = 7;
                            return fetch("".concat(requests/* ERequestUrl.apiGouvFr */.KU.apiGouvFr, "/").concat(dayjs_min_default()().add(1, 'y').year(), ".json"));
                        case 7:
                            responsePlusOne = _ctx.sent;
                            _ctx.next = 10;
                            return responseNow.json();
                        case 10:
                            dataNow = _ctx.sent;
                            _ctx.next = 13;
                            return responsePlusOne.json();
                        case 13:
                            dataPlusOne = _ctx.sent;
                            data = _objectSpread({}, dataNow, dataPlusOne);
                            setPublicHolidays(new Set(Object.keys(data)));
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _ctx.prev = 17;
                            for(_iterator = Object.entries(data)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                _value = _slicedToArray(_step.value, 1), key = _value[0];
                                daysOffArr.push(dayjs_min_default()(key).toDate());
                            }
                            _ctx.next = 25;
                            break;
                        case 21:
                            _ctx.prev = 21;
                            _ctx.t0 = _ctx["catch"](17);
                            _didIteratorError = true;
                            _iteratorError = _ctx.t0;
                        case 25:
                            _ctx.prev = 25;
                            _ctx.prev = 26;
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        case 28:
                            _ctx.prev = 28;
                            if (!_didIteratorError) {
                                _ctx.next = 31;
                                break;
                            }
                            throw _iteratorError;
                        case 31:
                            return _ctx.finish(28);
                        case 32:
                            return _ctx.finish(25);
                        case 33:
                            if (isMounted) {
                                setDaysOff(daysOffArr);
                                if (excludedDatesStart.length === 0) {
                                    setExcludedDatesStart(daysOffArr);
                                }
                                if (excludedDatesEnd.length === 0) {
                                    setExcludedDatesEnd(daysOffArr);
                                }
                            }
                            _ctx.next = 39;
                            break;
                        case 36:
                            _ctx.prev = 36;
                            _ctx.t1 = _ctx["catch"](0);
                            console.error('Error fetching days off:', _ctx.t1);
                        case 39:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        36
                    ],
                    [
                        17,
                        21,
                        25,
                        33
                    ],
                    [
                        26,
                        ,
                        28,
                        32
                    ]
                ]);
            }));
            return function fetchDaysOff() {
                return _ref.apply(this, arguments);
            };
        }();
        if (true) {
            fetchDaysOff();
        }
        return function() {
            isMounted = false;
        };
    }, [
        excludedDatesStart,
        excludedDatesEnd
    ]);
    var filterDate = function(date) {
        var disabledByBusinessRules = (0,businessDays/* isNonBusinessDay */.ow)(dayjs_min_default()(date), isSaturdayABusinessDay, publicHolidays, disableSundayFromCms);
        var majeLast = getMajeRentalLastDay();
        if (majeLast && dayjs_min_default()(date).isAfter(majeLast, 'day')) {
            return false;
        }
        var weekDay = dayjs_min_default()(date).day();
        var configWeekDayAndNumber = {
            0: !!(text === null || text === void 0 ? void 0 : text.disable_sunday_on_date_picker),
            1: !!(text === null || text === void 0 ? void 0 : text.disable_monday_on_date_picker),
            6: !!(text === null || text === void 0 ? void 0 : text.disable_saturday_on_date_picker)
        };
        if (disabledByBusinessRules || configWeekDayAndNumber[weekDay]) {
            return false;
        }
        return true;
    };
    var handleOpen = function() {
        setCalendarFade(true);
        hasReduction && setDisplayTooltip(false);
    };
    var handleClose = function() {
        setCalendarFade(false);
        hasReduction && setDisplayTooltip(true);
    };
    var handleSubscriptionDayChange = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(date) {
            var ref, subscriptionDate;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setDateLoading(true);
                        trackEvent({
                            category: "DatePicker",
                            action: "User select ".concat(dayjs_min_default()(date).format('DD/MM/YYYY'), " as StartDate")
                        });
                        _ctx.prev = 2;
                        if (!(cart && cart.item)) {
                            _ctx.next = 15;
                            break;
                        }
                        ;
                        if (!((cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.checkoutState) === 'cart')) {
                            _ctx.next = 11;
                            break;
                        }
                        subscriptionDate = dayjs_min_default()(date).format('DD/MM/YYYY');
                        _ctx.next = 9;
                        return patchDatesCart({
                            startRentingDate: subscriptionDate
                        });
                    case 9:
                        _ctx.next = 15;
                        break;
                    case 11:
                        _ctx.next = 13;
                        return deleteCart(true);
                    case 13:
                        _ctx.next = 15;
                        return createCart(dayjs_min_default()(date), null, warehouseId);
                    case 15:
                        _ctx.next = 20;
                        break;
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](2);
                        console.error('Error in handleSubscriptionDayChange:', _ctx.t0);
                    case 20:
                        _ctx.prev = 20;
                        setDateLoading(false);
                        return _ctx.finish(20);
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    17,
                    20,
                    23
                ]
            ]);
        }));
        return function handleSubscriptionDayChange(date) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleStartDayChange = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(date) {
            var endDatePlusOne, ref, startDate, endDate, ref41, dateRange, ref42, startDate1, endDate1, ref43, startDate2, endDate2, startDate3, endDate3, excludeDateArray, i;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setDateLoading(true);
                        trackEvent({
                            category: "DatePicker",
                            action: "User select ".concat(dayjs_min_default()(date).format('DD/MM/YYYY'), " as StartDate")
                        });
                        _ctx.prev = 2;
                        if (!(cart && cart.item)) {
                            _ctx.next = 52;
                            break;
                        }
                        endDatePlusOne = dayjs_min_default()(date).add(minDateRange - 1, 'day');
                        if (!(dayjs_min_default()(cart.item.endLeasingDate, 'DD/MM/YYYY') <= dayjs_min_default()(date))) {
                            _ctx.next = 20;
                            break;
                        }
                        ;
                        if (!((cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.checkoutState) === 'cart')) {
                            _ctx.next = 14;
                            break;
                        }
                        startDate = dayjs_min_default()(date).format('DD/MM/YYYY');
                        endDate = dayjs_min_default()(endDatePlusOne).format('DD/MM/YYYY');
                        _ctx.next = 12;
                        return patchDatesCart({
                            startRentingDate: startDate,
                            endRentingDate: endDate,
                            oneDayDuration: startDate === endDate ? dayDuration : null
                        });
                    case 12:
                        _ctx.next = 18;
                        break;
                    case 14:
                        _ctx.next = 16;
                        return deleteCart(true);
                    case 16:
                        _ctx.next = 18;
                        return createCart(dayjs_min_default()(date), dayjs_min_default()(endDatePlusOne), warehouseId);
                    case 18:
                        _ctx.next = 50;
                        break;
                    case 20:
                        ;
                        dateRange = dayjs_min_default()(cart.item.endLeasingDate, 'DD/MM/YYYY').diff(dayjs_min_default()(date), 'day');
                        if (!(dateRange > minimumLeasingDays - 1)) {
                            _ctx.next = 38;
                            break;
                        }
                        ;
                        if (!(dateRange <= (parameters === null || parameters === void 0 ? void 0 : (ref42 = parameters.items) === null || ref42 === void 0 ? void 0 : ref42.maximumLeasingDays))) {
                            _ctx.next = 31;
                            break;
                        }
                        startDate1 = dayjs_min_default()(date).format('DD/MM/YYYY');
                        endDate1 = cart.item.endLeasingDate;
                        _ctx.next = 29;
                        return patchDatesCart({
                            startRentingDate: startDate1,
                            endRentingDate: endDate1,
                            oneDayDuration: startDate1 === endDate1 ? dayDuration : null
                        });
                    case 29:
                        _ctx.next = 36;
                        break;
                    case 31:
                        ;
                        startDate2 = dayjs_min_default()(date).format('DD/MM/YYYY');
                        endDate2 = dayjs_min_default()(date).add((parameters === null || parameters === void 0 ? void 0 : (ref43 = parameters.items) === null || ref43 === void 0 ? void 0 : ref43.maximumLeasingDays) - 1, 'day').format('DD/MM/YYYY');
                        _ctx.next = 36;
                        return patchDatesCart({
                            startRentingDate: startDate2,
                            endRentingDate: endDate2,
                            oneDayDuration: startDate2 === endDate2 ? dayDuration : null
                        });
                    case 36:
                        _ctx.next = 42;
                        break;
                    case 38:
                        startDate3 = dayjs_min_default()(date).format('DD/MM/YYYY');
                        endDate3 = dayjs_min_default()(endDatePlusOne).format('DD/MM/YYYY');
                        _ctx.next = 42;
                        return patchDatesCart({
                            startRentingDate: dayjs_min_default()(date).format('DD/MM/YYYY'),
                            endRentingDate: dayjs_min_default()(endDatePlusOne).format('DD/MM/YYYY'),
                            oneDayDuration: startDate3 === endDate3 ? dayDuration : null
                        });
                    case 42:
                        if (!((cart === null || cart === void 0 ? void 0 : (ref41 = cart.item) === null || ref41 === void 0 ? void 0 : ref41.checkoutState) === 'cart')) {
                            _ctx.next = 46;
                            break;
                        }
                        {
                        // endDate > startDate selected by customer
                        // put dates with selected date as startDate and current endDate
                        }
                        _ctx.next = 50;
                        break;
                    case 46:
                        _ctx.next = 48;
                        return deleteCart(true);
                    case 48:
                        _ctx.next = 50;
                        return createCart(dayjs_min_default()(date), dayjs_min_default()(cart.item.endLeasingDate), warehouseId);
                    case 50:
                        _ctx.next = 55;
                        break;
                    case 52:
                        if (!(0,businessDays/* isStartDateAlignedWithSylius */.f4)()) {
                            _ctx.next = 55;
                            break;
                        }
                        _ctx.next = 55;
                        return createCart(dayjs_min_default()(date), dayjs_min_default()(date).add(minDateRange - 1, 'day'), warehouseId);
                    case 55:
                        excludeDateArray = _toConsumableArray(daysOff);
                        for(i = 0; i < minDateRange - 1; i++){
                            excludeDateArray.push(dayjs_min_default()(date).add(i, 'day').toDate());
                        }
                        setExcludedDatesEnd(excludeDateArray);
                        _ctx.next = 63;
                        break;
                    case 60:
                        _ctx.prev = 60;
                        _ctx.t0 = _ctx["catch"](2);
                        console.error('Error in handleStartDayChange:', _ctx.t0);
                    case 63:
                        _ctx.prev = 63;
                        setDateLoading(false);
                        return _ctx.finish(63);
                    case 66:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    60,
                    63,
                    66
                ]
            ]);
        }));
        return function handleStartDayChange(date) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleEndDayChange = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(date) {
            var ref, startDate, endDate, ref44, startDateMinusOne, startDate4, endDate4, startDateMinusOne1, excludeDateArray, i;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setDateLoading(true);
                        trackEvent({
                            category: "DatePicker",
                            action: "User select ".concat(dayjs_min_default()(date).format('DD/MM/YYYY'), " as EndDate")
                        });
                        _ctx.prev = 2;
                        if (!(cart && cart.item)) {
                            _ctx.next = 36;
                            break;
                        }
                        if (!(dayjs_min_default()(date).diff(dayjs_min_default()(cart.item.startLeasingDate, 'DD/MM/YYYY'), 'd') > 0)) {
                            _ctx.next = 19;
                            break;
                        }
                        ;
                        if (!((cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.checkoutState) === 'cart')) {
                            _ctx.next = 13;
                            break;
                        }
                        startDate = dayjs_min_default()(cart.item.startLeasingDate, 'DD/MM/YYYY').format('DD/MM/YYYY');
                        endDate = dayjs_min_default()(date).format('DD/MM/YYYY');
                        _ctx.next = 11;
                        return patchDatesCart({
                            startRentingDate: startDate,
                            endRentingDate: endDate,
                            oneDayDuration: startDate === endDate ? dayDuration : null
                        });
                    case 11:
                        _ctx.next = 17;
                        break;
                    case 13:
                        _ctx.next = 15;
                        return deleteCart(true);
                    case 15:
                        _ctx.next = 17;
                        return createCart(dayjs_min_default()(cart.item.startLeasingDate, 'DD/MM/YYYY'), dayjs_min_default()(date), warehouseId);
                    case 17:
                        _ctx.next = 32;
                        break;
                    case 19:
                        ;
                        startDateMinusOne = dayjs_min_default()(date).subtract(minDateRange - 1, 'day');
                        if (!((cart === null || cart === void 0 ? void 0 : (ref44 = cart.item) === null || ref44 === void 0 ? void 0 : ref44.checkoutState) === 'cart')) {
                            _ctx.next = 28;
                            break;
                        }
                        startDate4 = dayjs_min_default()(startDateMinusOne).format('DD/MM/YYYY');
                        endDate4 = dayjs_min_default()(date).format('DD/MM/YYYY');
                        _ctx.next = 26;
                        return patchDatesCart({
                            startRentingDate: startDate4,
                            endRentingDate: endDate4,
                            oneDayDuration: startDate4 === endDate4 ? dayDuration : null
                        });
                    case 26:
                        _ctx.next = 32;
                        break;
                    case 28:
                        _ctx.next = 30;
                        return deleteCart(true);
                    case 30:
                        _ctx.next = 32;
                        return createCart(dayjs_min_default()(startDateMinusOne), dayjs_min_default()(date), warehouseId);
                    case 32:
                        startDateMinusOne1 = dayjs_min_default()(date).subtract(minDateRange - 1, 'day');
                        excludeDateArray = _toConsumableArray(daysOff);
                        for(i = 0; i < minDateRange - 2; i++){
                            excludeDateArray.push(dayjs_min_default()(startDateMinusOne1).add(i, 'day').toDate());
                        }
                        setExcludedDatesEnd(excludeDateArray);
                    case 36:
                        _ctx.next = 41;
                        break;
                    case 38:
                        _ctx.prev = 38;
                        _ctx.t0 = _ctx["catch"](2);
                        console.error('Error in handleEndDayChange:', _ctx.t0);
                    case 41:
                        _ctx.prev = 41;
                        setDateLoading(false);
                        return _ctx.finish(41);
                    case 44:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    38,
                    41,
                    44
                ]
            ]);
        }));
        return function handleEndDayChange(date) {
            return _ref.apply(this, arguments);
        };
    }();
    var onSubmit = function(e) {
        var ref, ref45;
        e.preventDefault();
        router.pathname === '/' ? router.push('/shop') : (0,utils/* scrollToDiv */.cx)(scrollTarget);
        if ((cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.endLeasingDate) && (cart === null || cart === void 0 ? void 0 : (ref45 = cart.item) === null || ref45 === void 0 ? void 0 : ref45.startLeasingDate)) {
            var rentingPeriod = dayjs_min_default()(cart.item.endLeasingDate, 'DD/MM/YYYY').diff(dayjs_min_default()(cart.item.startLeasingDate, 'DD/MM/YYYY'), 'd') + 1;
            trackEvent({
                category: 'DatePicker',
                href: '/shop',
                action: "User clicked on start button and want to rent for ".concat(rentingPeriod, " days")
            });
        }
    };
    (0,react.useEffect)(function() {
        var isMounted = true;
        if (cart === null || cart === void 0 ? void 0 : cart.item) {
            var promotionPercentage = 0;
            var start = dayjs_min_default()(cart.item.startLeasingDate, 'DD/MM/YYYY').format();
            var end = dayjs_min_default()(cart.item.endLeasingDate, 'DD/MM/YYYY').format();
            var range = dayjs_min_default()(end).diff(dayjs_min_default()(start), 'day') + 1;
            var calculPromotion = function() {
                var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                    var ref52, result, ref46, ref47, ref48;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.prev = 0;
                                ;
                                if (!((promotions === null || promotions === void 0 ? void 0 : (ref52 = promotions.items) === null || ref52 === void 0 ? void 0 : ref52.length) > 0 || promotions.fetched)) {
                                    _ctx.next = 6;
                                    break;
                                }
                                _ctx.t0 = {
                                    type: 'GET_PROMOTIONS_SUCCESS',
                                    promotions: promotions.items
                                };
                                _ctx.next = 9;
                                break;
                            case 6:
                                _ctx.next = 8;
                                return getPromotions1();
                            case 8:
                                _ctx.t0 = _ctx.sent;
                            case 9:
                                result = _ctx.t0;
                                if (result.type === 'GET_PROMOTIONS_SUCCESS') {
                                    if ((result === null || result === void 0 ? void 0 : result.promotions.length) > 0) {
                                        ;
                                        result === null || result === void 0 ? void 0 : (ref46 = result.promotions) === null || ref46 === void 0 ? void 0 : ref46.map(function(promo) {
                                            // check if this is only a rules on the dates, otherwise skip
                                            var checkRule = promo === null || promo === void 0 ? void 0 : promo.rules.find(function(rule) {
                                                return rule.type === 'number_of_leasing_day';
                                            });
                                            if (typeof checkRule !== 'undefined' && !promo.coupon_based) {
                                                var ref, ref49, ref50, ref51;
                                                // Find the right percentage of promotion based on dateRange
                                                if (range >= ((ref = promo === null || promo === void 0 ? void 0 : promo.rules[0]) === null || ref === void 0 ? void 0 : (ref49 = ref.configuration) === null || ref49 === void 0 ? void 0 : ref49.from) && range <= ((ref50 = promo === null || promo === void 0 ? void 0 : promo.rules[0]) === null || ref50 === void 0 ? void 0 : (ref51 = ref50.configuration) === null || ref51 === void 0 ? void 0 : ref51.to)) {
                                                    promotionPercentage = promo.actions.length !== 0 ? promo.actions[0].configuration.percentage : 0;
                                                }
                                            }
                                        });
                                        // CHeck if last promotion should be applied for even more day than the range setup
                                        if (range > ((ref47 = result === null || result === void 0 ? void 0 : result.promotions[(result === null || result === void 0 ? void 0 : result.promotions.length) - 1].rules[0]) === null || ref47 === void 0 ? void 0 : ref47.configuration.to) && !(result === null || result === void 0 ? void 0 : result.promotions[(result === null || result === void 0 ? void 0 : result.promotions.length) - 1].coupon_based)) {
                                            ;
                                            promotionPercentage = (ref48 = result === null || result === void 0 ? void 0 : result.promotions[(result === null || result === void 0 ? void 0 : result.promotions.length) - 1].actions[0]) === null || ref48 === void 0 ? void 0 : ref48.configuration.percentage;
                                        }
                                        if (isMounted) {
                                            if (typeof promotionPercentage === 'number' && promotionPercentage !== 0) {
                                                setReduction(Math.round(promotionPercentage * 100));
                                                setCurrentPromotion1(Math.round(promotionPercentage * 100));
                                                setHasReduction(true);
                                            } else {
                                                setHasReduction(false);
                                                setCurrentPromotion1(null);
                                            }
                                        }
                                    }
                                }
                                _ctx.next = 16;
                                break;
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t1 = _ctx["catch"](0);
                                console.error('Error calculating promotion:', _ctx.t1);
                            case 16:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            0,
                            13
                        ]
                    ]);
                }));
                return function calculPromotion() {
                    return _ref.apply(this, arguments);
                };
            }();
            calculPromotion();
        }
        return function() {
            isMounted = false;
        };
    }, [
        cart === null || cart === void 0 ? void 0 : (ref9 = cart.item) === null || ref9 === void 0 ? void 0 : ref9.startLeasingDate,
        cart === null || cart === void 0 ? void 0 : (ref10 = cart.item) === null || ref10 === void 0 ? void 0 : ref10.endLeasingDate
    ]);
    var MyContainer = function(param) {
        var className = param.className, children = param.children;
        var hasTextUnderCalendar = (0,CMSText/* isPrismicText */.LT)(text === null || text === void 0 ? void 0 : text.small_text_under_calendar);
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)([
                'datePicker',
                hasTextUnderCalendar && classes.datePickerWithText,
                calendarFade ? "datepicker ".concat(classes.show) : "datepicker ".concat(classes.hide), 
            ]),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: className,
                    children: children
                }),
                hasTextUnderCalendar && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)(classes.backgroundSolid, 'datePicker__background'),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)(classes.datePickerText, 'datePicker__text'),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            data: text.small_text_under_calendar,
                            defaultText: t('texts:general:small_text_under_calendar')
                        })
                    })
                })
            ]
        }));
    };
    var ButtonInput = /*#__PURE__*/ react.forwardRef(function(param, ref) {
        var value = param.value, onClick = param.onClick, id = param.id;
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Button/* default */.Z, {
            disableRipple: true,
            size: "large",
            className: "daterange__btn ".concat(classes.mobileInput),
            onClick: onClick,
            ref: ref,
            "data-testid": "daterange-".concat(id),
            children: value === '' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                variant: "text",
                width: '10ch'
            }) : value
        });
    });
    var handleDayDuration = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(event) {
            var ref, ref53, ref54, ref55;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        setDayDuration(event === null || event === void 0 ? void 0 : (ref = event.target) === null || ref === void 0 ? void 0 : ref.value);
                        _ctx.prev = 2;
                        ;
                        _ctx.next = 6;
                        return patchDatesCart({
                            startRentingDate: cart === null || cart === void 0 ? void 0 : (ref53 = cart.item) === null || ref53 === void 0 ? void 0 : ref53.startLeasingDate,
                            endRentingDate: cart === null || cart === void 0 ? void 0 : (ref54 = cart.item) === null || ref54 === void 0 ? void 0 : ref54.endLeasingDate,
                            oneDayDuration: event === null || event === void 0 ? void 0 : (ref55 = event.target) === null || ref55 === void 0 ? void 0 : ref55.value
                        });
                    case 6:
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](2);
                        console.error('Error in handleDayDuration:', _ctx.t0);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    8
                ]
            ]);
        }));
        return function handleDayDuration(event) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,clsx_m/* default */.Z)(classes.shopLayout, isLanding && classes.shopLayoutLanding),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: onSubmit,
                className: classes.root,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)('daterange__container', constants/* enableHalfDay */.L0 && classes.daterangeOneDay),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,clsx_m/* default */.Z)('daterange', classes.when, dateLoading && classes.whenLoading, constants/* enableHalfDay */.L0 && classes.whenOneDay),
                                children: [
                                    dateLoading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                "data-testid": "daterange-loading",
                                                className: classes.loaderOverlay,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.loaderSizer
                                            })
                                        ]
                                    }),
                                    isEnableChooseStartingDate && constants/* isSubscription */.Nn && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            CalendarIcon,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((react_datepicker_min_default()), {
                                                locale: currentLocale,
                                                dateFormat: "P",
                                                selected: cart && cart.item && !(cart === null || cart === void 0 ? void 0 : cart.loading) && cart.item.startLeasingDate !== undefined ? dayjs_min_default()(cart.item.startLeasingDate, 'DD/MM/YYYY').toDate() : null,
                                                placeholderText: 'DD/MM/YYYY',
                                                ref: startRef,
                                                filterDate: filterDate,
                                                excludeDates: excludedDatesStart,
                                                onChange: function(date) {
                                                    return handleSubscriptionDayChange(date);
                                                },
                                                selectsStart: true,
                                                minDate: minStartDate,
                                                maxDate: (ref11 = getMajeRentalLastDay()) === null || ref11 === void 0 ? void 0 : ref11.toDate(),
                                                withPortal: isMobile,
                                                name: 'startDate',
                                                className: classes.datepicker,
                                                calendarContainer: MyContainer,
                                                showPopperArrow: false,
                                                popperClassName: "react-datepicker-popper--no-triangle",
                                                popperModifiers: {
                                                    offset: {
                                                        enabled: false
                                                    }
                                                },
                                                onCalendarOpen: handleOpen,
                                                onCalendarClose: handleClose,
                                                id: "start"
                                            })
                                        ]
                                    }),
                                    !isEnableChooseStartingDate && !constants/* isFlex */.Lz && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            CalendarIcon,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((react_datepicker_min_default()), {
                                                locale: currentLocale,
                                                dateFormat: "P",
                                                selected: cart && cart.item && !(cart === null || cart === void 0 ? void 0 : cart.loading) && cart.item.startLeasingDate !== undefined ? dayjs_min_default()(cart.item.startLeasingDate, 'DD/MM/YYYY').toDate() : null,
                                                ref: startRef,
                                                filterDate: filterDate,
                                                excludeDates: excludedDatesStart,
                                                onChange: function(date) {
                                                    return handleStartDayChange(date);
                                                },
                                                selectsStart: true,
                                                customInput: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonInput, {
                                                    value: cart === null || cart === void 0 ? void 0 : (ref12 = cart.item) === null || ref12 === void 0 ? void 0 : ref12.startLeasingDate,
                                                    onClick: true
                                                }),
                                                startDate: cart && cart.item && cart.item.startLeasingDate !== undefined && dayjs_min_default()(cart.item.startLeasingDate, 'DD/MM/YYYY').toDate(),
                                                minDate: minStartDate,
                                                maxDate: (ref13 = getMajeRentalLastDay()) === null || ref13 === void 0 ? void 0 : ref13.toDate(),
                                                withPortal: isMobile,
                                                name: 'startDate',
                                                onChangeRaw: handleDateChangeRaw,
                                                endDate: cart && cart.item && cart.item.endLeasingDate !== undefined && dayjs_min_default()(cart.item.endLeasingDate, 'DD/MM/YYYY').toDate(),
                                                className: classes.datepicker,
                                                calendarContainer: MyContainer,
                                                showPopperArrow: false,
                                                popperClassName: "react-datepicker-popper--no-triangle",
                                                popperModifiers: {
                                                    offset: {
                                                        enabled: false
                                                    }
                                                },
                                                onCalendarOpen: handleOpen,
                                                onCalendarClose: handleClose,
                                                id: "start"
                                            }),
                                            hasReduction && cart.loading !== true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MainTooltip, {
                                                placement: isDesktop ? 'top' : 'bottom',
                                                PopperProps: {
                                                    disablePortal: true,
                                                    className: (0,clsx_m/* default */.Z)('daterange_popper', 'MuiTooltip-popper', 'MuiTooltip-popperArrow')
                                                },
                                                open: displayTooltip,
                                                title: "".concat((0,CMSText/* prismicText */.yz)(text === null || text === void 0 ? void 0 : text.you_save, t('texts:general:you_save')), " ").concat(reduction.toFixed(0), " %"),
                                                arrow: true,
                                                enterDelay: 2000,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* default */.Z, {
                                                    className: (0,clsx_m/* default */.Z)('daterange__icon', 'daterange__icon--arrow', classes.iconArrow)
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* default */.Z, {
                                                className: (0,clsx_m/* default */.Z)('daterange__icon', 'daterange__icon--arrow', classes.iconArrow)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((react_datepicker_min_default()), {
                                                locale: currentLocale,
                                                dateFormat: "P",
                                                selected: cart && cart.item && !(cart === null || cart === void 0 ? void 0 : cart.loading) && cart.item.endLeasingDate !== undefined ? dayjs_min_default()(cart.item.endLeasingDate, 'DD/MM/YYYY').toDate() : null,
                                                ref: endRef,
                                                onChange: function(date) {
                                                    return handleEndDayChange(date);
                                                },
                                                onChangeRaw: handleDateChangeRaw,
                                                selectsEnd: true,
                                                name: 'endDate',
                                                withPortal: isMobile,
                                                customInput: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonInput, {
                                                    value: cart === null || cart === void 0 ? void 0 : (ref14 = cart.item) === null || ref14 === void 0 ? void 0 : ref14.endLeasingDate,
                                                    onClick: true
                                                }),
                                                startDate: cart && cart.item && cart.item.startLeasingDate !== undefined && dayjs_min_default()(cart.item.startLeasingDate, 'DD/MM/YYYY').toDate(),
                                                endDate: cart && cart.item && cart.item.startLeasingDate !== undefined ? dayjs_min_default()(cart.item.endLeasingDate, 'DD/MM/YYYY').toDate() : minEndDate,
                                                minDate: minEndDate,
                                                maxDate: getRentalEndMaxDate(cart === null || cart === void 0 ? void 0 : (ref15 = cart.item) === null || ref15 === void 0 ? void 0 : ref15.startLeasingDate, parameters === null || parameters === void 0 ? void 0 : (ref16 = parameters.items) === null || ref16 === void 0 ? void 0 : ref16.maximumLeasingDays),
                                                openToDate: cart && cart.item && cart.item.startLeasingDate !== undefined ? dayjs_min_default()(cart.item.startLeasingDate, 'DD/MM/YYYY').toDate() : minStartDate,
                                                className: classes.datepicker,
                                                calendarContainer: MyContainer,
                                                filterDate: filterDate,
                                                excludeDates: excludedDatesEnd,
                                                showPopperArrow: false,
                                                popperClassName: "react-datepicker-popper--no-triangle",
                                                popperModifiers: {
                                                    offset: {
                                                        enabled: false
                                                    }
                                                },
                                                onCalendarOpen: handleOpen,
                                                onCalendarClose: handleClose,
                                                id: "end"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            constants/* enableHalfDay */.L0 && (cart === null || cart === void 0 ? void 0 : (ref17 = cart.item) === null || ref17 === void 0 ? void 0 : ref17.startLeasingDate) === (cart === null || cart === void 0 ? void 0 : (ref18 = cart.item) === null || ref18 === void 0 ? void 0 : ref18.endLeasingDate) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                                variant: "outlined",
                                className: classes.formControl,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                    value: dayDuration,
                                    onChange: handleDayDuration,
                                    className: (0,clsx_m/* default */.Z)('contact_select', classes.dayDurationSelctor),
                                    children: dayDurationValues.map(function(option, index) {
                                        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: option.value,
                                            children: (0,CMSText/* prismicText */.yz)(option === null || option === void 0 ? void 0 : option.text, option.defaultText)
                                        }, index));
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.order2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            disabled: !(cart === null || cart === void 0 ? void 0 : (ref19 = cart.item) === null || ref19 === void 0 ? void 0 : ref19.startLeasingDate) || !(cart === null || cart === void 0 ? void 0 : (ref20 = cart.item) === null || ref20 === void 0 ? void 0 : ref20.endLeasingDate) || cart.loading,
                            "data-testid": "submitDates",
                            variant: "contained",
                            color: "secondary",
                            size: "large",
                            type: "submit",
                            onClick: onSubmit,
                            className: (0,clsx_m/* default */.Z)('daterange__submit', classes.btnSubmit),
                            children: isLanding ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                asText: true,
                                data: text === null || text === void 0 ? void 0 : text.start_button,
                                defaultText: t('texts:general:start_button')
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                asText: true,
                                data: text === null || text === void 0 ? void 0 : text.confirm_button,
                                defaultText: t('texts:general:confirm_button')
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.order1,
                        children: !isLanding && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShippingInfos/* default */.Z, {
                            startDate: cart === null || cart === void 0 ? void 0 : (ref21 = cart.item) === null || ref21 === void 0 ? void 0 : ref21.startLeasingDate,
                            endDate: cart === null || cart === void 0 ? void 0 : (ref22 = cart.item) === null || ref22 === void 0 ? void 0 : ref22.endLeasingDate,
                            deliverDuration: parameters === null || parameters === void 0 ? void 0 : (ref23 = parameters.items) === null || ref23 === void 0 ? void 0 : ref23.deliverDuration,
                            returnDuration: parameters === null || parameters === void 0 ? void 0 : (ref24 = parameters.items) === null || ref24 === void 0 ? void 0 : ref24.returnDuration,
                            loading: parameters === null || parameters === void 0 ? void 0 : parameters.loading,
                            t: t,
                            text: textFunnel,
                            isEnableChooseStartingDate: isEnableChooseStartingDate
                        })
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ var DateRangeForm = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(DateRangeForm_DateRange));


/***/ }),

/***/ 18919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Fh": function() { return /* binding */ promotions_getPromotions; },
  "rs": function() { return /* binding */ setCurrentPromotion; },
  "mW": function() { return /* binding */ setFuturePrice; }
});

// UNUSED EXPORTS: ACTIONS, GET_PROMOTIONS_FAILURE, GET_PROMOTIONS_REQUEST, GET_PROMOTIONS_SUCCESS, SET_CURRENT_PROMOTION, SET_FUTUR_PRICE

// EXTERNAL MODULE: ./redux/helpers/api.ts + 1 modules
var api = __webpack_require__(12664);
// EXTERNAL MODULE: ./redux/helpers/requests.ts
var requests = __webpack_require__(20031);
;// CONCATENATED MODULE: ./redux/services/promotionsService.ts


var getPromotions = function() {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* ERequestUrl.promotions */.KU.promotions
    });
};

;// CONCATENATED MODULE: ./redux/actions/promotions.ts

var ACTIONS = {
    GET_PROMOTIONS_REQUEST: 'GET_PROMOTIONS_REQUEST',
    GET_PROMOTIONS_SUCCESS: 'GET_PROMOTIONS_SUCCESS',
    GET_PROMOTIONS_FAILURE: 'GET_PROMOTIONS_FAILURE',
    SET_FUTUR_PRICE: 'SET_FUTUR_PRICE',
    SET_CURRENT_PROMOTION: 'SET_CURRENT_PROMOTION'
};
var GET_PROMOTIONS_REQUEST = function() {
    return {
        type: ACTIONS.GET_PROMOTIONS_REQUEST
    };
};
var GET_PROMOTIONS_SUCCESS = function(promotions) {
    return {
        type: ACTIONS.GET_PROMOTIONS_SUCCESS,
        promotions: promotions
    };
};
var GET_PROMOTIONS_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_PROMOTIONS_FAILURE,
        err: err
    };
};
function promotions_getPromotions() {
    return function(dispatch) {
        dispatch(GET_PROMOTIONS_REQUEST());
        return getPromotions().then(function(response) {
            return dispatch(GET_PROMOTIONS_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_PROMOTIONS_FAILURE(err));
        });
    };
}
var SET_FUTUR_PRICE = function(price) {
    return {
        type: ACTIONS.SET_FUTUR_PRICE,
        price: price
    };
};
var SET_CURRENT_PROMOTION = function(currentPromotion) {
    return {
        type: ACTIONS.SET_CURRENT_PROMOTION,
        currentPromotion: currentPromotion
    };
};
function setCurrentPromotion(currentPromotion) {
    return function(dispatch) {
        dispatch(SET_CURRENT_PROMOTION(currentPromotion));
    };
}
function setFuturePrice(price) {
    return function(dispatch) {
        dispatch(SET_FUTUR_PRICE(price));
    };
}


/***/ }),

/***/ 67202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f4": function() { return /* binding */ isStartDateAlignedWithSylius; },
/* harmony export */   "ow": function() { return /* binding */ isNonBusinessDay; },
/* harmony export */   "uO": function() { return /* binding */ getMinimumStartDate; },
/* harmony export */   "nN": function() { return /* binding */ getFirstSelectableDate; }
/* harmony export */ });
/* unused harmony export isSelectableDate */
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* provided dependency */ var process = __webpack_require__(34155);

/**
 * ALIGN_START_DATE_WITH_SYLIUS="true" (Volcom only for now): count the lead
 * time like Sylius `DateTimeUtil::isFreeDay`, which always closes Sundays —
 * otherwise Sylius refuses the start date we send — and start automatically
 * created carts on a date the CMS lets customers pick.
 */ var isStartDateAlignedWithSylius = function() {
    return process.env.ALIGN_START_DATE_WITH_SYLIUS === 'true';
};
var isNonBusinessDay = function(date, isSaturdayABusinessDay, publicHolidays, /** When set from Prismic `disable_sunday_on_date_picker`, Sundays are non-business. */ disableSundayFromCms) {
    var day = date.day();
    var isSunday = day === 0;
    var isSaturday = day === 6;
    var isHoliday = publicHolidays.has(date.format('YYYY-MM-DD'));
    return !!disableSundayFromCms && isSunday || !isSaturdayABusinessDay && isSaturday || isHoliday;
};
var getMinimumStartDate = function(minimumStartingDays, isSaturdayABusinessDay, publicHolidays, disableSundayFromCms) {
    var startDate = dayjs__WEBPACK_IMPORTED_MODULE_0___default()();
    var businessDaysCount = 0;
    while(businessDaysCount < minimumStartingDays){
        startDate = startDate.add(1, 'day');
        if (!isNonBusinessDay(startDate, isSaturdayABusinessDay, publicHolidays, disableSundayFromCms) && !(isStartDateAlignedWithSylius() && startDate.day() === 0)) {
            businessDaysCount += 1;
        }
    }
    return startDate;
};
// A CMS blocked range can span months: this only guards against a config
// that closes every single day.
var MAX_DAYS_SEARCHED = 730;
var isInCmsBlockedRange = function(date, cms) {
    if (!(cms === null || cms === void 0 ? void 0 : cms.blocked_dates_start) || !(cms === null || cms === void 0 ? void 0 : cms.blocked_dates_end)) return false;
    var start = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(cms.blocked_dates_start);
    var end = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(cms.blocked_dates_end);
    if (!start.isValid() || !end.isValid()) return false;
    return !date.isBefore(start, 'day') && !date.isAfter(end, 'day');
};
/** Same rules as the date picker's `filterDate` + blocked range (`excludeDates`). */ var isSelectableDate = function(date, isSaturdayABusinessDay, publicHolidays, cms) {
    var day = date.day();
    if (isNonBusinessDay(date, isSaturdayABusinessDay, publicHolidays, !!(cms === null || cms === void 0 ? void 0 : cms.disable_sunday_on_date_picker))) {
        return false;
    }
    if (day === 1 && (cms === null || cms === void 0 ? void 0 : cms.disable_monday_on_date_picker)) return false;
    if (day === 6 && (cms === null || cms === void 0 ? void 0 : cms.disable_saturday_on_date_picker)) return false;
    return !isInCmsBlockedRange(date, cms);
};
/** First date from `from` on that the customer could pick; `from` if none. */ var getFirstSelectableDate = function(from, isSaturdayABusinessDay, publicHolidays, cms) {
    var date = from;
    for(var i = 0; i < MAX_DAYS_SEARCHED; i++){
        if (isSelectableDate(date, isSaturdayABusinessDay, publicHolidays, cms)) {
            return date;
        }
        date = date.add(1, 'day');
    }
    return from;
};


/***/ })

}]);